var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Checks if an object has a given key
// In contrast to a raw call, this function
// a) adds the necessary type narrowing, and
// b) calls `hasOwnProperty` over its prototype, thereby making sure no-one overwrote it
export function hasOwnProperty(o, key) {
    return Object.prototype.hasOwnProperty.call(o, key);
}
export function tryGetPropertyPath(d, path) {
    var e_1, _a;
    try {
        for (var path_1 = __values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
            var key = path_1_1.value;
            if (typeof d !== "object" || d instanceof Array || d === null)
                return undefined;
            if (!d.hasOwnProperty(key))
                return undefined;
            d = d[key];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return d;
}
export function hasSubOject(o, key) {
    return hasOwnProperty(o, key) && typeof o[key] === "object" && o[key] !== null;
}
// Try to convert to string. Return undefined if not succesful.
export function tryToString(d) {
    if (typeof d === "string") {
        return d;
    }
    else if (typeof d === "number") {
        return d.toString();
    }
    else if (typeof d === "boolean") {
        return d.toString();
    }
    else if (d === null) {
        return "null";
    }
    else if (d === undefined) {
        return "undefined";
    }
    return undefined;
}
// Convert to string. Returns the JSON serialization if not supported.
export function forceToString(d) {
    var str = tryToString(d);
    if (str === undefined) {
        str = JSON.stringify(d);
    }
    return str;
}
export function jsonToStringMap(json) {
    var e_2, _a;
    var parsedJSON;
    try {
        parsedJSON = JSON.parse(json);
    }
    catch (err) {
        throw new Error("JSON parse failed with '" + err + "'.");
    }
    if (typeof parsedJSON !== "object" || Array.isArray(parsedJSON) || parsedJSON === null) {
        throw new Error("Expected a JSON object");
    }
    var result = new Map();
    try {
        for (var _b = __values(Object.keys(parsedJSON)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = parsedJSON[key];
            var strValue = tryToString(value);
            if (strValue === undefined) {
                throw new Error("Expected a string value, got " + typeof value);
            }
            result.set(key, strValue);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
}
// Format a number using metric suffixes
export function formatMetric(x) {
    var sizes = ["", "k", "M", "G", "T", "P", "E", "Z", "Y"];
    var idx = 0;
    while (x > 1000 && idx < sizes.length - 1) {
        x /= 1000;
        ++idx;
    }
    return x.toFixed(0) + sizes[idx];
}
export function assert(value, errorMsg) {
    if (errorMsg === void 0) { errorMsg = "Assertion violated"; }
    if (!value) {
        // eslint-disable-next-line no-debugger
        debugger;
        throw new Error(errorMsg);
    }
}
export function assertNotNull(v) {
    assert(v !== null, "Unexpected null value");
    assert(v !== undefined, "Unexpected undefined value");
}
